import { render } from "./FeederWithComponent.vue?vue&type=template&id=f16165fe&scoped=true"
import script from "./FeederWithComponent.vue?vue&type=script&lang=js"
export * from "./FeederWithComponent.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-f16165fe"

export default script